import * as Types from '../action.types';
import * as Models from '../../models/index';
import axios from 'axios';
import { navigateToTracks } from '../../infrastructure/toolbox';

export const tryGetTokenAndOpenTracks = (userName: string, password: string) => {
    return new Promise((resolve, reject) => {
        axios.post('/auth/signin', { userName: userName, password: password }, { withCredentials: true }).then(response => {
            if (response.data?.IsSuccess)
                setTimeout(function () {
                    navigateToTracks(window.location.hash);
                }, 500);
            else {
                reject(response.data);
            }
        });
    });
};

export const login = () => (d: Function, gs: () => Models.StoreState) => {
    var { userName, password } = gs().login;
    userName = gs().shell.redirectUserName || userName;
    const urlForNotAppropriateUser = gs().shell.urlForNotAppropriateUser;
    d({
        type: Types.CHANGE_LOGIN_PROCESSING_STATUS,
        payload: true,
    });
    tryGetTokenAndOpenTracks(userName, password).catch(responseData => {
        d({
            type: Types.CHANGE_LOGIN_PROCESSING_STATUS,
            payload: false,
        });
        switch (responseData.Error) {
            case 'password-expired': {
                window.location.hash = '/password expired';
                return;
            }
            case 'change-password': {
                d({
                    type: Types.SET_IS_NEEDED_TO_CHANGE_PWD,
                    payload: true,
                });
                window.location.hash = '/forced change password';
                return;
            }
            case 'user_login_not_allowed_to_tracks':
            case 'user_login_not_allowed_to_pretracks': {
                window.location.href = `${urlForNotAppropriateUser}/login#!?error=${responseData.Error}`;
                return;
            }
            default:
                d({
                    type: Types.SET_LOGIN_RESPONSE,
                    payload: {
                        isSuccess: false,
                        isMultipleSignIn: false,
                        redirectUrl: null,
                        fullname: null,
                        errors: [responseData.ErrorDescription],
                        isPwdExpiredDate: false,
                        isNeededToChangePWD: false,
                    },
                });
        }
    });
};

export const changeUsername = (userName: string) => ({
    type: Types.CHANGE_LOGIN_USERNAME,
    payload: userName as Types.CHANGE_LOGIN_USERNAME_PAYLOAD,
});

export const changePassword = (password: string) => ({
    type: Types.CHANGE_LOGIN_PASSWORD,
    payload: password as Types.CHANGE_LOGIN_PASSWORD_PAYLOAD,
});
